import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoamersRoutingModule } from './roamers-routing.module';
import { RoamersSegmentComponent } from './roamers-segment/roamers-segment.component';
import { RoamersCountHistoryComponent } from './roamers-count-history/roamers-count-history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule, MatMenuModule, MatToolbarModule, MatButtonModule, MatIconModule, MatTableModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatDialogModule, MatListModule, MatTooltipModule } from '@angular/material';
import { NgbDatepickerModule, NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SharedModule } from '../theme/shared/shared.module';
import { ViewRoamersSegmentDataComponent } from './view-roamers-segment-data/view-roamers-segment-data.component';
import { PricePointHistoryComponent } from './price-point-history/price-point-history.component';
import { RoamersPackHistoryComponent } from './roamers-pack-history/roamers-pack-history.component';
import { RoamfreeInErrorCodeComponent } from './roamfree-in-error-code/roamfree-in-error-code.component';
import { MessageCountComponent } from './message-count/message-count.component';
import { RepitiveCountComponent } from './repitive-count/repitive-count.component';
import {VlridUnblockCountComponent} from './vlrid-unblock-count/vlrid-unblock-count.component'
import { InStatisticsComponent } from './in-statistics/in-statistics.component';
import { MessageDeliveryStatisticsComponent } from './message-delivery-statistics/message-delivery-statistics.component';
import { BarComponent } from './bar/bar.component';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { DeleteCampaignDialogComponent } from './delete-campaign-dialog/delete-campaign-dialog.component';
import { AddCampaignComponent } from './campaign/add-campaign/add-campaign.component';
import { CampaignDataTableComponent } from './campaign/campaign-data-table/campaign-data-table.component';
//import { CampaignComponent } from './campaign/campaign.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { RrmsDayWiseReportsComponent } from './rrms-day-wise-reports/rrms-day-wise-reports.component';
import { RrmsDayWiseReportsDataTableComponent } from './rrms-day-wise-reports-data-table/rrms-day-wise-reports-data-table.component';
import {RrmsActiveDeactiveMsissdnComponent} from "./rrms-active-deactive-msisdn/rrms-active-deactive-msisdn.component";
@NgModule({
  declarations: [
    RoamersSegmentComponent,
    RoamersCountHistoryComponent,
    ViewRoamersSegmentDataComponent,
    PricePointHistoryComponent,
    RoamersPackHistoryComponent,
    RoamfreeInErrorCodeComponent,
    MessageCountComponent,
    RepitiveCountComponent,
    InStatisticsComponent,
    MessageDeliveryStatisticsComponent,
    RrmsDayWiseReportsComponent,
    RrmsDayWiseReportsDataTableComponent,
    VlridUnblockCountComponent,
    RrmsActiveDeactiveMsissdnComponent,
  ],
  imports: [
    CommonModule,
    RoamersRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDatepickerModule,
    DataTablesModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    NgMultiSelectDropDownModule,
    MultiSelectAllModule,
    CheckBoxModule,
    ButtonModule,
    NumericTextBoxModule,
    Ng4LoadingSpinnerModule.forRoot(),
    MatMenuModule,
    SharedModule,
    NgbModule,
    DataTablesModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  entryComponents: []
})
export class RoamersModule { }
